<div class="view-wrapper list-page crm-contact-list">
  <dx-data-grid
    class="grid theme-dependent"
    noDataText=""
    height="100%"
    [dataSource]="dataSource"
    [allowColumnReordering]="true"
    [focusedRowEnabled]="true"
    [showBorders]="true"
    [(focusedRowKey)]="userId"
    (onRowClick)="rowClick($event)"
    (onExporting)="onExporting($event)"
  >
    <dxo-load-panel [showPane]="false"></dxo-load-panel>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-selection
      selectAllMode="allPages"
      showCheckBoxesMode="always"
      mode="multiple"
    ></dxo-selection>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
    <dxo-search-panel
      [visible]="true"
      placeholder="Contact Search"
    ></dxo-search-panel>
    <dxo-export
      [enabled]="true"
      [allowExportSelectedData]="true"
      [formats]="['xlsx', 'pdf']"
    >
    </dxo-export>

    <dxo-toolbar>
      <dxi-item location="before">
        <div class="grid-header">Contacts</div>
      </dxi-item>
      <dxi-item location="before" locateInMenu="auto">
        <dx-drop-down-button
          stylingMode="text"
          [useSelectMode]="true"
          [items]="filterStatusList"
          [dropDownOptions]="{ width: 'auto' }"
          [selectedItemKey]="filterStatusList[0]"
          (onSelectionChanged)="filterByStatus($event)"
        ></dx-drop-down-button>
      </dxi-item>
      <dxi-item location="after" locateInMenu="auto">
        <dx-button
          text="Add Contact"
          icon="plus"
          type="default"
          stylingMode="contained"
          (onClick)="addContact()"
        ></dx-button>
      </dxi-item>
      <dxi-item
        location="after"
        locateInMenu="auto"
        showText="inMenu"
        widget="dxButton"
        [options]="{
          text: 'Refresh',
          icon: 'refresh',
          onClick: refresh,
          stylingMode: 'text'
        }"
      ></dxi-item>
      <dxi-item location="after" locateInMenu="auto">
        <div class="separator"></div>
      </dxi-item>
      <dxi-item name="exportButton"></dxi-item>
      <dxi-item location="after" locateInMenu="auto">
        <div class="separator"></div>
      </dxi-item>
      <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
      <dxi-item name="searchPanel" locateInMenu="auto"></dxi-item>
    </dxo-toolbar>

    <dxi-column
      dataField="name"
      caption="Name"
      sortOrder="asc"
      [hidingPriority]="5"
      [minWidth]="150"
      cellTemplate="name"
    ></dxi-column>
    <dxi-column
      dataField="company"
      caption="Company"
      [hidingPriority]="5"
      [minWidth]="150"
    ></dxi-column>
    <dxi-column
      dataField="status"
      caption="Status"
      cellTemplate="cellStatus"
      editCellTemplate="editCellStatus"
      [hidingPriority]="3"
      [minWidth]="100"
    ></dxi-column>
    <dxi-column
      dataField="assignedTo"
      caption="Assigned to"
      [hidingPriority]="4"
    ></dxi-column>
    <dxi-column
      dataField="phone"
      caption="Phone"
      [customizeText]="customizePhoneCell"
      [hidingPriority]="2"
    ></dxi-column>
    <dxi-column
      dataField="email"
      caption="Email"
      [hidingPriority]="1"
    ></dxi-column>

    <div *dxTemplate="let cellInfo of 'name'" class="name-template">
      <div>
        <div>{{ cellInfo.data.name }}</div>
        <div class="position">{{ cellInfo.data.position }}</div>
      </div>
    </div>

    <div *dxTemplate="let cellInfo of 'cellStatus'">
      <contact-status [value]="cellInfo.data.status"></contact-status>
    </div>

    <div *dxTemplate="let cellInfo of 'editCellStatus'">
      <dx-select-box
        class="edit-cell"
        [(value)]="cellInfo.value"
        [items]="statusList"
        (onValueChanged)="cellInfo.setValue($event.value)"
        (onSelectionChanged)="cellInfo.component.updateDimensions()"
        fieldTemplate="field"
      >
        <div *dxTemplate="let data of 'field'">
          <contact-status [value]="cellInfo.value"></contact-status>
          <dx-text-box [readOnly]="true"></dx-text-box>
        </div>
        <div *dxTemplate="let data of 'item'">
          <contact-status [value]="data"></contact-status>
        </div>
      </dx-select-box>
    </div>
  </dx-data-grid>

  <contact-panel
    [userId]="userId"
    [(isOpened)]="isPanelOpened"
    (isOpenedChange)="onOpenedChange($event)"
    (pinnedChange)="onPinnedChange()"
  >
  </contact-panel>

  <form-popup [(visible)]="isAddContactPopupOpened" (save)= "onClickSaveNewContact()" titleText="New Contact">
    <contact-new-form></contact-new-form>
  </form-popup>
</div>
